/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMessageSearchResult } from './APIMessageSearchResult';
import {
    APIMessageSearchResultFromJSON,
    APIMessageSearchResultFromJSONTyped,
    APIMessageSearchResultToJSON,
} from './APIMessageSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIMessageSearchResponse
 */
export interface APIMessageSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIMessageSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIMessageSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIMessageSearchResult>}
     * @memberof APIMessageSearchResponse
     */
    results: Array<APIMessageSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIMessageSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIMessageSearchResponse interface.
 */
export function instanceOfAPIMessageSearchResponse(value: object): value is APIMessageSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIMessageSearchResponseFromJSON(json: any): APIMessageSearchResponse {
    return APIMessageSearchResponseFromJSONTyped(json, false);
}

export function APIMessageSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMessageSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIMessageSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIMessageSearchResponseToJSON(value?: APIMessageSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIMessageSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

